import { createSlice } from '@reduxjs/toolkit'

const reelSlice = createSlice({
    name: 'reels',
    initialState: {
      reels: [
        
      ]
    }
    ,
    reducers: {
        updateReels: (state, action) => {
            state.reels = action.payload;
        }
    }
})

export const {updateReels} = reelSlice.actions;
export default reelSlice.reducer;
